import {animation, availableAnimations} from "@global/global-animation";
import * as Hammer from "hammerjs";
import {breakpoints} from "@utilities/sal-breakpoint/sal-breakpoint";

let fadeDuration = "1000ms";

//TODO: Add something for tests to disable automatic animations
let autostepping = window.IS_DEBUG ? false : null;
let switchingImage = false;

const eventListeners = {
    next: () => {
        if (switchingImage) {
            return
        }

        methods.stopAutoStepping();

        const currentImage = methods.NSQuerySelector('.js-active');
        const nextImage = currentImage.nextElementSibling;

        if (nextImage) {
            // methods.checkButtonStates(nextImage);
            methods.switch(currentImage, nextImage);
        } else {
            methods.switch(currentImage, currentImage.parentNode.firstElementChild)
        }
    },
    prev: () => {
        if (switchingImage) {
            return
        }

        methods.stopAutoStepping();

        const currentImage = methods.NSQuerySelector('.js-active');
        const prevImage = currentImage.previousElementSibling;

        if (prevImage) {
            // methods.checkButtonStates(prevImage);
            methods.switch(currentImage, prevImage);
        } else {
            methods.switch(currentImage, currentImage.parentNode.lastElementChild)
        }
    }
};

const methods = {
    switch(currentImage, nextImage) {
        switchingImage = true;
        currentImage.style.zIndex = 0;
        nextImage.style.zIndex = 1;

        nextImage.style.position = 'absolute';
        nextImage.style.display = 'block';

        const gallery = methods.NSQuerySelector(`.${options.galleryWrapper}`);
        const slides = gallery.childNodes;
        slides.forEach((element, index) => {
            if (element === nextImage) {
                setTimeout(() => {
                    methods.updatePageIndicator(index + 1);
                }, 200); // Damit der User sieht, dass etwas passiert, wenn er klickt/swiped nicht erst nachm Bildwechsel
            }
        });

        animation.addAnimation(nextImage, availableAnimations.fades.fadeIn, fadeDuration, [{
            eventType: 'animationend',
            eventCallback: () => {
                switchingImage = false;
                currentImage.classList.remove('js-active');
                nextImage.classList.add('js-active');
                nextImage.style.position = '';
                nextImage.style.display = '';
                methods.startAutoNextStep();
            }
        }]);
    },
    NSQuerySelector(selector) {
        return document.querySelector(`${options.namespace} ${selector}`);
    },
    NSQuerySelectorAll(selector) {
        return document.querySelectorAll(`${options.namespace} ${selector}`);
    },
    checkButtonStates(activeImage) {
        const nextBtn = methods.NSQuerySelector(`.${options.btnNextClass}`);
        const prevBtn = methods.NSQuerySelector(`.${options.btnPrevClass}`);
        if (activeImage.nextElementSibling) {
            nextBtn.classList.remove("inactive");
            if (nextBtn.hasAttribute("disabled")) {
                nextBtn.removeAttribute("disabled");
            }
        } else {
            nextBtn.classList.add("inactive");
            nextBtn.setAttribute("disabled", '');
        }

        if (activeImage.previousElementSibling) {
            prevBtn.classList.remove("inactive");
            if (prevBtn.hasAttribute("disabled")) {
                prevBtn.removeAttribute("disabled");
            }
        } else {
            prevBtn.classList.add("inactive");
            prevBtn.setAttribute("disabled", '');
        }
    },
    updatePageIndicator: (activeIndex) => {
        const gallery = methods.NSQuerySelector(`.${options.galleryWrapper}`);
        const slides = gallery.childNodes;
        if (typeof activeIndex !== 'number') {
            slides.forEach((element, index) => {
                if (element.classList.contains("js-active")) {
                    activeIndex = index + 1;
                }
            });
        }

        // Page number
        const count = slides.length;
        methods.NSQuerySelector(".page-indicator").innerHTML = `${activeIndex}/${count}`;

        // mobile bullet-indicators
        const indicatorWrapper = methods.NSQuerySelector('.gallery__indicator');
        if (indicatorWrapper) {
            const activeIndicator = methods.NSQuerySelector('.indicator--active');
            if (activeIndicator) {
                activeIndicator.classList.remove('indicator--active');
            }

            const newActiveIndicator = methods.NSQuerySelector(`.gallery__indicator .indicator:nth-child(${activeIndex})`);
            newActiveIndicator.classList.add('indicator--active');
        }
    },
    createIndicator: (numberOfIndicators) => {
        let i = 0;
        let indicatorWrapper = document.createElement('div');
        indicatorWrapper.classList.add('gallery__indicator');
        let indicator = document.createElement('span');
        indicator.classList.add('indicator');

        while (i < numberOfIndicators) {
            indicatorWrapper.appendChild(indicator.cloneNode(true));
            i++;
        }

        indicatorWrapper.firstChild.classList.add('indicator--active');

        return indicatorWrapper;
    },

    startAutoNextStep: () => {
        if (autostepping !== false) {
            const progressBar = methods.NSQuerySelector(`.${options.progressBarClass}`);
            if (progressBar) {
                progressBar.style.width = 0;

                const animationEndFn = () => {
                    progressBar.style.width = 0;
                    if (autostepping !== false) {
                        const currentImage = methods.NSQuerySelector('.js-active');
                        const nextImage = currentImage.nextElementSibling;

                        if (nextImage) {
                            // methods.checkButtonStates(nextImage);
                            methods.switch(currentImage, nextImage);
                        } else {
                            methods.switch(currentImage, currentImage.parentNode.firstElementChild)
                        }
                    }
                };

                if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                    progressBar.style.visibility = 'hidden';
                    // Reduced motion means that animate.js forces the dduration to 1ms, thus the progress bar cannot be used.
                    // Crappy library if "prefer" "reduced" means "no animation at all" ;-)
                    setTimeout(animationEndFn, extractMilliseconds(options.progressBarDuration));
                }
                else {
                    animation.addAnimation(progressBar, 'animate_ref_entry_progress', options.progressBarDuration, [{
                        eventType: 'animationend',
                        eventCallback: animationEndFn
                    }]);
                }
            }
        }
    },
    stopAutoStepping: () => {
        const progressBar = methods.NSQuerySelector(`.${options.progressBarClass}`);

        autostepping = false;
        if (progressBar) {
            progressBar.style.display = 'none';
        }
    }
};

let options = {
    namespace: '.global-gallery',
    galleryWrapper: 'global-gallery__wrapper',
    btnNextClass: 'btn-next',
    btnPrevClass: 'btn-prev',
    progressBarClass: 'progress-indicator',
    progressBarDuration: '5s',
    galleryTouchThreshold: 80,
    breakpointCondition: () => {
        return window.innerWidth >= breakpoints.lg;
    },
};

const globalGallery = {
    // TODO To have multiple galleries with the same wrapper classes on one page this needs to be rewritten, so that the dom element is passed to the init function and all queries are scoped to that element; not via document.querySelector
    // TODO AND.. after looking at it a few seconds longer. Properly scope the options object to the init function and don't use a global options object that gets overwritten/reused on every init call.
    init: (namespace, galleryItemWrapperClass) => {
        options.namespace = namespace;
        options.galleryWrapper = galleryItemWrapperClass;
        const galleryRoot = methods.NSQuerySelector(`.${options.galleryWrapper}`);
        if (galleryRoot) {
            if (galleryRoot.dataset.interval) {

                const interval = parseInt(galleryRoot.dataset.interval);
                if (interval === 0) {
                    autostepping = false;
                } else {
                    options.progressBarDuration = interval + "s"
                }
            }
            // methods.checkButtonStates(methods.NSQuerySelector(".js-active"));
            methods.NSQuerySelector(`.${options.btnNextClass}`).addEventListener('click', eventListeners.next);
            methods.NSQuerySelector(`.${options.btnPrevClass}`).addEventListener('click', eventListeners.prev);
            methods.updatePageIndicator();

            let observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0.0
            };
            const observerCallback = () => {
                if (autostepping === null) {
                    methods.startAutoNextStep();
                }
            };
            const observer = new IntersectionObserver(observerCallback, observerOptions);
            observer.observe(galleryRoot);

            let hammerInstances = [];
            if (!options.breakpointCondition()) {
                const touchArea = galleryRoot;
                const numberIndicators = touchArea.childNodes.length;

                if (touchArea.nextSibling) {
                    touchArea.parentNode.insertBefore(methods.createIndicator(numberIndicators), touchArea.nextSibling);
                } else {
                    touchArea.parentNode.append(methods.createIndicator(numberIndicators));
                }

                const hammerInstance = new Hammer(touchArea);
                hammerInstance.get('swipe').set({
                    direction: Hammer.DIRECTION_HORIZONTAL,
                    threshold: options.galleryTouchThreshold
                });
                hammerInstance.on('swipeleft', eventListeners.next);
                hammerInstance.on('swiperight', eventListeners.prev);
                hammerInstances.push(hammerInstance); // ???
            }
        }
    }
};


function extractMilliseconds(progressBarDuration) {
    const regex = /(\d+)(s|ms)/; // Regular expression pattern
    const match = progressBarDuration.match(regex); // Match the pattern in the string

    if (match) {
        const value = parseInt(match[1]); // Extract the numerical value
        const unit = match[2]; // Extract the unit (s or ms)

        if (unit === 's') {
            return value * 1000; // Convert seconds to milliseconds
        } else if (unit === 'ms') {
            return value; // The value is already in milliseconds
        }
    }

    // Return a default value or handle the case when the string doesn't match the expected format
    return 5000;
}

export {globalGallery};
